import React from 'react';
import fr from 'facet-rest';
import { FDStack } from '@facet-wealth/design';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import {
  FadeInBox,
} from 'Views/Page/Content/Templates/WizardTemplates/ScenarioSelectionRedefined/ScenarioSelectionRedefinedCommon/ExecuteSelectLoadingPage/FadeInBox';
import { InflowsMoneyFlowsSectionContainer } from './InflowsMoneyFlowsSection';

export const ProposalInflowsSectionLayout = () => {
  const { resource } = useMetaLayoutContext();

  return (
    <FadeInBox>
      <FDStack direction={'column'} alignItems={'center'} spacing={5} width={'100%'}>
        <MetaControlField attr={'title'} />
        <MetaControlField attr={'subtitle'} />
        {resource.withRelationship(fr.relationships.proposalYearAheadMoneyFlowSection.name, (rel) => {
          return (<InflowsMoneyFlowsSectionContainer relationship={rel} />);
        }, () => null)}
      </FDStack>
    </FadeInBox>
  );
};
